<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
      <div class="qrcode">
        <div class="item">
          <div class="qrcode-wrapper">
            <div class="img">
              <img src=".././assets/cg.png" alt />
            </div>
          </div>
          <h3 class="title">扫码购参观门票</h3>
        </div>
        <div class="item">
          <div class="qrcode-wrapper">
            <div class="img">
              <img src=".././assets/cg.png" alt />
            </div>
          </div>
          <h3 class="title">扫码购电影票</h3>
        </div>
      </div>
    </div>
    <h3 class="titles">欢迎使用自助售取票机</h3>
    <div class="content">
      <div class="item" @click="goTicket">
        <h3>参观门票</h3>
        <p>Ticket</p>
      </div>
      <div class="item" @click="goMovie">
        <h3>电影票</h3>
        <p>Cinema Ticket</p>
      </div>
    </div>
    <div class="footer">
      <p>
       <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850 25650860</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { setInterval, clearInterval } from "timers";
export default {
  name: "HelloWorld",
  data() {
    return {
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      timer: ""
    };
  },
  mounted() {
    //
    this.getDay();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          break;
        case 1:
          strWeek = "星期一";
          break;
        case 2:
          strWeek = "星期二";
          break;
        case 3:
          strWeek = "星期三";
          break;
        case 4:
          strWeek = "星期四";
          break;
        case 5:
          strWeek = "星期五";
          break;
        case 6:
          strWeek = "星期六";
          break;
      }
      this.time = hours + ":" + min;
      this.today = month + "月" + days + "日 " + strWeek;
    },
    // 前往门票系统
    goTicket() {
      this.$router.push("/ticket");
    },
    // 前往影院系统
    goMovie() {
      this.$router.push("/movie");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  background: url(.././assets/bg.png) no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
  padding-bottom: 165px;
  .top {
    padding: 30px 32px;
    color: #fff;
    font-size: 25px;
    h3 {
      font-size: 70px;
      margin: 0;
    }
    .qrcode {
      width: 850px;
      margin: 0px auto;
      display: flex;
      .item {
        padding: 20px 50px;
        .qrcode-wrapper {
          padding: 5px;
          text-align: center;
          .img {
            width: 290px;
            margin: 0 auto 48px;
            display: block;
            height: auto;
            padding: 13px;
            border-radius: 8px;
            background: #fff;
            box-shadow: 0px 30px 28px #005f9b;
            img {
              width: 250px;
              height: auto;
              display: block;
            }
          }
        }
        .title {
          font-size: 48px;
          font-weight: 500;
          white-space: nowrap;
          letter-spacing: 3px;
        }
      }
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: center;
    margin: 131px;
  }
}
.content {
  padding: 0 60px;
  overflow: hidden;
  .item {
    width: 450px;
    height: 520px;
    float: left;
    border-radius: 6px;
    background: url(.././assets/movie.png) no-repeat;
    background-size: cover;
    &:first-child {
      margin-right: 60px;
      background: url(.././assets/t.png) no-repeat;
      background-size: cover;
    }
    h3 {
      text-align: right;
      margin-top: 320px;
      color: #fff;
      font-size: 70px;
      letter-spacing: 4px;
      padding-right: 40px;
    }
    p {
      margin-top: 10px;
      text-align: right;
      color: #fff;
      font-size: 36px;
      padding-right: 40px;
    }
  }
}
.footer {
  position: absolute;
  bottom: 0;
  padding: 60px;
  font-size: 24px;
  width: 100%;
  left: 0;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue